module.exports = __webpack_public_path__ + "img/Frame_40.7f0061a1.png";